<template>
    <v-row class="pb-3">
        <v-col cols="2" class="pb-5">
            <SearchFilter 
                @keydown.enter="filter" 
                :context="context" 
                :alvqa="alvqa + '-textfield-search'"
            />
        </v-col>
        <span class="pt-7">
            <BaseIcon 
                :alvqa="alvqa + '-icon-search'"
                @click="filter" 
                icon="fa-search" 
                tooltipText="lang_GENERAL_CAPTION_START_SEARCH" 
            />
        </span>
        <v-col 
            cols="2" 
            align-self="center"
            class="pt-6"
        >
            <BaseButton 
                :disabled="!showDeleteResultListButton"
                @click="deleteResultlist"
                label="lang_GENERIC_CAPTION_DELETE"
                :alvqa="alvqa + '-button-delete-result'"
                block
            />
        </v-col>
        <v-col 
            cols="4"
            align-self="center"
            class="v-label theme--light mt-2"
        >
            <BaseHeaderStats 
                context="WorksForSubCatalogues" 
                typeStats="LIST"
                :alvqa="alvqa"
                :specificSelected="$store.getters.getTotalListed"
            />
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="3" align-self="center" class="pt-6">
            <BaseButton 
                @click="addWorks"
                label="lang_CONTRACTS_PUBLISHING_ADD_WORKS_DIALOG_TITLE"
                :alvqa="alvqa + '-button-add-row'"
                block
            />
        </v-col>
    </v-row>
</template>

<script>
import BaseButton from '@/components/_buttons/BaseButton'
import SearchFilter from '@/components/_filters/SearchFilter'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'

export default {
    name: "PublishingContractsSubCataloguesEditPanelTopSlot",
    components: {
        BaseButton,
        BaseIcon,
        SearchFilter,
        BaseHeaderStats
    },
    props: {
        subcatalogue: Object
    },
    data() {
        return {
            alvqa: 'contracts-publishing-edit-form-panel-subcatalogues',
            context: 'PublishingContractsSubCataloguesWorks'
        }
    },
    computed: {
        showDeleteResultListButton() { return this.$store.getters.getShowSubCataloguesWorksDeleteResultListButton }
    },
    methods: {
        addWorks() {
            this.$store.commit('setSelectedPublishingContractsSubCatalogues', this.subcatalogue.alvId)
            this.$store.commit('setShowSearchSubCataloguesWorksDialog', true)
        },
        filter() {
            this.$store.commit('setCurrentPage', 1)
            this.$store.commit('setPublishingContractsSubCataloguesWorks', [])
            this.$store.dispatch('fetchPublishingContractsSubCataloguesWorks', this.subcatalogue.alvId)
        },
        deleteResultlist() {
            this.$store.commit('setSelectedPublishingContractsSubCatalogues', this.subcatalogue.alvId)
            this.$store.commit('setDeletionDialogContext', 'AllWorksFromSubCatalogues')
            this.$store.commit('setShowDeletionDialog', true)
        }
    }
}
</script>